import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { StatePersistService } from './state-persist.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(false);
  private message: string;
  public headerCreateEventSubject: BehaviorSubject<boolean>;
  public openSignIn: BehaviorSubject<boolean>;


  constructor(
    private router: Router,
    private stateService: StatePersistService,
    private http: HttpClient
  ) {
    this.message = '';
    this.openSignIn = new BehaviorSubject<boolean>(false);
    this.headerCreateEventSubject = new BehaviorSubject<boolean>(false);
  }

  
  get header() {
    return this.headerCreateEventSubject.asObservable();
  }

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  login(objUserDetails: any) {
    this.message = '';
    this.stateService.setLocalStorage('currentUser', objUserDetails, 'user_update');
    this.loggedIn.next(true);
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.loggedIn.next(false);
  }

  getMessage(): string {
    return this.message;
  }

}
